export const endpoints = {
  auth: '/api/auth',
  device: '/api/devices',
  familyGroup: '/api/familygroups',
  message: '/api/messages',
  pairingToken: '/api/pairing-token',
  systemSound: '/api/system-sounds',
}
